<template>
  <div class="exam-result-for-student-page">
    <div class="header">
      <div class="user-info" v-if="student">
        <img :src="student.head_img_url" />
        <div class="info">
          <div class="name">{{ _show_student_name(student) }}</div>
          <div class="clazz-name">{{ clazzName }}</div>
        </div>
      </div>
      <div class="score-box">
        <div class="tip">考试得分</div>
        <div class="score">{{ studentPaper.star_score }}</div>
      </div>

      <div class="title">【{{ title }}】 答题明细</div>

      <div class="over-view">
        <div class="item" v-for="(item, index) in summaryItems" :key="index">
          <div class="label">{{ item.label }}</div>
          <div class="value" :class="{ error: item.label === '错误' || item.label === '未完成' }">{{ item.value }}</div>
        </div>
      </div>

      <div class="answer-list">
        <student-question-info
          :question-info="question"
          :seq-no="index + 1"
          :key="index"
          v-for="(question, index) in studentPaper.questions"
        ></student-question-info>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { BasePage, Component, Prop } from 'kuaidong-component'
import { AWinter2023 } from 'kuaidong-api'
import { IExamStudentPaper } from 'kuaidong-model'
import StudentQuestionInfo from '@/views/pe-knowledge/components/StudentQuestionInfo.vue'
@Component({
  components: {
    StudentQuestionInfo,
  },
})
export default class KnowledgeExamResultForStudentPage extends BasePage {
  @Prop({ type: String, required: true })
  onlineExamClassId!: string

  @Prop({ type: String, required: true })
  userId!: string

  @Prop({ type: String, required: true })
  clazzName!: string

  @Prop({ type: String, required: true })
  title!: string

  studentPaper: IExamStudentPaper | null = null

  get student() {
    return this.studentPaper?.student_vo
  }

  get summaryItems() {
    return [
      {
        label: '全部',
        value: this.studentPaper?.total_quantity,
      },

      {
        label: '正确',
        value: this.studentPaper?.correct_quantity,
      },

      {
        label: '错误',
        value: this.studentPaper?.wrong_quantity,
      },

      {
        label: '未完成',
        value: this.studentPaper?.undo_quantity,
      },
    ]
  }

  async created() {
    this.fetchStudentPaper()
  }

  async fetchStudentPaper() {
    try {
      this.studentPaper = await AWinter2023.examStatisticStudentPaper(this.onlineExamClassId, this.userId)
    } catch (e) {
      this.$message.warning(e.data)
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less">
.exam-result-for-student-page {
  > .header {
    background: #fff;
    padding: 16px;

    > .user-info {
      display: flex;
      align-items: center;
      > img {
        width: 56px;
        height: 56px;
        border-radius: 50%;
      }

      > .info {
        display: flex;
        flex-direction: column;
        margin-left: 16px;
        align-items: flex-start;
        > .name {
          font-weight: 600;
          font-size: 18px;
          line-height: 25px;
          color: #2d2f33;
        }
        > .clazz-name {
          margin-top: 2px;
          font-weight: 500;
          font-size: 12px;
          line-height: 17px;
          color: #939599;
        }
      }
    }

    > .title {
      margin-top: 24px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      color: #4d4d4d;
      text-align: left;
    }

    > .score-box {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      padding-bottom: 24px;
      border-bottom: 1px solid #dcdde0;
      > .tip {
        font-weight: 500;
        font-size: 12px;
        line-height: 17px;
        color: #939599;
      }
      > .score {
        font-weight: 700;
        font-size: 40px;
        line-height: 40px;
        color: #ff5d2f;
      }
    }

    > .over-view {
      display: flex;
      justify-content: space-around;
      margin-top: 24px;
      > .item {
        > .value {
          margin-top: 6px;
          font-weight: 700;
          font-size: 24px;
          line-height: 26px;
          color: #2d2f33;
          &.error {
            color: #f24b53;
          }
        }
        > .label {
          font-weight: 500;
          font-size: 14px;
          line-height: 22px;
          color: #9da2a9;
        }
      }
    }

    > .answer-list {
      display: flex;
      flex-direction: column;
      width: 582px;
      justify-content: center;
      margin: 0 auto;
    }
  }
}
</style>
